import React from 'react';
import Moment from "moment";
import SignupErr from "./SignupErr";
import {format} from "date-fns";
import { de } from 'date-fns/locale'

const SignupDate = ({ err, viewings, prevStep, nextStep, setStep, apartment, handleChange, handleCheckboxChange, values, focusedTitleRef }) => {
    Moment.locale('de');

    const Continue = e => {
        e.preventDefault();
        nextStep();
    }

    const Previous = e => {
        e.preventDefault();
        prevStep();
    }

    const Back = e => {
        e.preventDefault();
        setStep(0);
    }

    return (
        <section>
			<div className="article-categories">
				<a href={`/wohnung/?id=${apartment.apartmentId}`} className="article-category">{apartment.title}</a>
			</div>
			<h1 ref={focusedTitleRef} tabIndex="-1"><span>Besichtigungstermine</span></h1>

			<SignupErr err={ err } />

			<div>
				<p>Bitte geben Sie alle Zeitfenster an, die für eine Besichtigung in Frage kommen:</p>
				{
					viewings.map((viewing) => {
						return (
							<div key={viewing.viewingId}>
								<div className="form-check">
									<input
										type={"checkbox"}
										value={viewing.viewingId}
										onChange={handleCheckboxChange('dates')}
										checked={values.dates.includes(viewing.viewingId.toString())}
										className="form-check-input"
										id={"viewing_" + viewing.viewingId}
									/>
									<label className="form-check-label fw-normal" htmlFor={"viewing_" + viewing.viewingId}>
										{format(new Date(viewing.viewingMeta.dateStart), "EEEE, dd. MMMM yyyy", {locale: de})}, zwischen {format(new Date(viewing.viewingMeta.dateStart), "HH:mm", {locale: de})} und {format(new Date(viewing.viewingMeta.dateEnd), "HH:mm", {locale: de})} Uhr
									</label>
								</div>
							</div>
						)
					})
				}
			</div>

			<div className="d-flex justify-content-between mt-5 flex-row-reverse">
				<button onClick={ Continue } className="btn btn-secondary">Weiter</button>
				<button onClick={ Previous } className="btn btn-secondary btn-back">Zurück</button>
			</div>
        </section>
    )

}

export default SignupDate
